<template>
  <div class="content">
    <!-- <el-container> -->
    <!-- <el-header> -->
    <div class="welcome flex justify-content-center align-items">
      <div class="page-width flex justify-content-space-between align-items">
        <div class="color-gray">尊敬的客户您好，欢迎来到奉航！</div>
        <div class="flex justify-content-space-between align-items">
          <div class="flex align-items" @click="navPath('10')">
            <img src="@/assets/user.png" alt="" style="width: 20px; height: 20px" />
            <span class="color-gray pageHeader-logo page-click">个人中心</span>
          </div>
          <div
            ref="pclogin"
            class="flex align-items"
            @click="loginClick"
            v-if="loginStatus == ''"
          >
            <img src="@/assets/phone.png" alt="" style="width: 27px; height: 27px" />
            <span class="color-gray pageHeader-logo page-click">手机登录</span>
          </div>
          <el-popover placement="bottom" trigger="hover" v-if="loginStatus == '1'">
            <div
              class="page-click flex align-items"
              style="padding-left: 10px"
              @click="backlogin"
            >
              <i class="el-icon-close"></i>
              <span style="margin-left: 5px">退出登录</span>
            </div>
            <div slot="reference" class="flex align-items">
              <img src="@/assets/phone.png" alt="" style="width: 27px; height: 27px" />
              <span class="color-gray pageHeader-logo page-click">{{
                logindata.phone
              }}</span>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="searchLogo flex justify-content-center align-items">
      <div class="page-width flex justify-content-space-between align-items">
        <div class="flex justify-content-between align-items page-click" @click="toHome">
          <img src="@/assets/logo.png" alt="" style="width: 113px" />
          <div>
            <p class="pageTitle-text" style="margin-bottom: 0">
              {{ siteData.name }}
            </p>
            <p class="pageTitle-text-fu" style="margin-bottom: 0">
              {{ siteData.nameEn }}
            </p>
          </div>
        </div>
        <div style="height: 73px" class="flex align-items">
          
          <!-- <p class="pageTitle-phone-fu" style="margin-bottom: 0">服务咨询热线</p> -->
        </div>
        <el-input
          class="el-input-zdy"
          v-model="search"
          @input="searchInput"
          @keyup.enter.native="searchChange"
          style="max-width: 430px"
          placeholder="产品搜索：如压力开关"
        >
          <img
            src="@/assets/search.png"
            slot="suffix"
            alt=""
            style="width: 25px; height: 25px; margin-top: 7.5px; margin-right: 10px"
          />
        </el-input>
      </div>
    </div>
    <div class="tabnav flex justify-content-center align-items">
      <div class="page-width flex justify-content-space-between align-items">
        <div class="flex align-items">
          <div class="tabnav-ever" @click="navPath('1')">首页</div>
          <el-divider direction="vertical"></el-divider>
          <el-dropdown placement="bottom" @command="toPath($event, '2')">
            <div class="tabnav-ever" @click="navPath('2')">{{ titleMenu[0].name }}</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="it.id"
                v-for="(it, i) in titleMenu[0].columnList"
                >{{ it.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-divider direction="vertical"></el-divider>
          <el-dropdown placement="bottom" @command="toPath($event, '3')">
            <div class="tabnav-ever" @click="navPath('3')">{{ titleMenu[1].name }}</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="it.id"
                v-for="(it, i) in titleMenu[1].columnList"
                >{{ it.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-divider direction="vertical"></el-divider>
          <el-dropdown placement="bottom" @command="toPath($event, '4')">
            <div class="tabnav-ever" @click="navPath('4')">{{ titleMenu[2].name }}</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="it.id"
                v-for="(it, i) in titleMenu[2].classificationDtoList"
                >{{ it.className }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-divider direction="vertical"></el-divider>
          <el-dropdown placement="bottom" @command="toPath($event, '5')">
            <div class="tabnav-ever" @click="navPath('5')">{{ titleMenu[3].name }}</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="it.id"
                v-for="(it, i) in titleMenu[3].columnList"
                >{{ it.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-divider direction="vertical"></el-divider>
          <el-dropdown placement="bottom" @command="toPath($event, '6')">
            <div class="tabnav-ever" @click="navPath('6')">{{ titleMenu[4].name }}</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="it.id"
                v-for="(it, i) in titleMenu[4].columnList"
                >{{ it.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-divider direction="vertical"></el-divider>
          <el-dropdown placement="bottom" @command="toPath($event, '7')">
            <div class="tabnav-ever" @click="navPath('7')">{{ titleMenu[5].name }}</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="it.id"
                v-for="(it, i) in titleMenu[5].columnList"
                >{{ it.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-divider direction="vertical"></el-divider>
          <div class="tabnav-ever" @click="tofixationPath('1')">人才招聘</div>
          <el-divider direction="vertical"></el-divider>
          <div class="tabnav-ever" @click="tofixationPath('2')">信息反馈</div>
        </div>
        <el-badge :value="shopCarNum" class="item" v-if="shopCarNum != 0">
          <div class="tabnav-ever" @click="navPath('9')">
            <i class="el-icon-shopping-cart-full" style="font-size: 30px"></i>购物车
          </div>
        </el-badge>
        <div class="tabnav-ever" @click="navPath('9')" v-if="shopCarNum == 0">
          <i class="el-icon-shopping-cart-full" style="font-size: 30px"></i>购物车
        </div>
      </div>
    </div>
    <div class="mobheader">
      <div class="mobheader-box flex justify-content-space-between align-items">
        <div class="mobheader-logo">
          <img src="@/assets/logo.png" alt="" />
          <p>陕西奉航</p>
        </div>
        <div class="mobheader-user flex align-items">
          <img src="@/assets/moblogo.png" @click="showPopup" alt="" />
          <img src="@/assets/shopcar.png" @click="navPath('9')" alt="" />
        </div>
        <div class="mobheader-menu flex align-items" @click="mobMenu">
          <img src="@/assets/menu.png" alt="" />
        </div>
      </div>
    </div>
    <van-popup
      class="mob-line"
      v-model="menuStatus"
      position="top"
      :style="{ top: '50px' }"
    >
      <div class="mob-menulist" style="padding-bottom: 10px">
        <van-cell title="首页" @click="navPath('1')" />
        <van-cell :title="titleMenu[0].name" @click="navPath('2')" />
        <van-cell :title="titleMenu[1].name" @click="navPath('3')" />
        <van-cell :title="titleMenu[2].name" @click="navPath('4')" />
        <van-cell :title="titleMenu[3].name" @click="navPath('5')" />
        <van-cell :title="titleMenu[4].name" @click="navPath('6')" />
        <van-cell :title="titleMenu[5].name" @click="navPath('7')" />
        <van-cell :title="titleMenu[6].name" @click="navPath('8')" />
        <van-search
          v-model="search"
          @input="searchInput"
          @search="searchChange"
          placeholder="产品搜索，如压力开关"
        >
          <img
            src="@/assets/search.png"
            slot="right-icon"
            alt=""
            style="width: 20px; height: 20px; margin-right: 10px"
          />
        </van-search>
      </div>
    </van-popup>
    <van-popup
      v-model="show"
      position="top"
      :style="{ top: '50px', 'padding-bottom': '30px' }"
    >
      <div
        style="width: 90%; margin-left: 5%; margin-top: 5px; margin-bottom: 10px"
        class="text-right"
      >
        <van-icon @click="closeshowPopup" name="cross" color="#999999" size="20px" />
      </div>
      <div style="width: 90%; margin-left: 5%">
        <van-cell-group>
          <van-field
            type="tel"
            v-model="userPhone"
            @input="phoneChange"
            oninput="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入手机号"
          />
          <van-field
            v-model="code"
            @input="codeChange"
            center
            clearable
            placeholder="请输入验证码"
          >
            <template #button>
              <span style="color: #0090ff" @click="codeClick" v-if="codeStatus == ''"
                >获取验证码</span
              >
              <span style="color: #999999" v-if="codeStatus == '1'">{{ codetime }}</span>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="flex justify-content-space-around">
        <div
          class="mob-login-btn flex justify-content-space-around align-items"
          @click="tologin"
        >
          登录
        </div>
      </div>
    </van-popup>
    <!-- </el-header> -->
    <!-- <el-main style="padding: 0"> -->
    <!-- 所有路由的总出口 -->
    <div class="mob-margin-top" style="width: 100%; min-height: 62vh">
      <router-view></router-view>
    </div>
    <!-- </el-main> -->
    <!-- <el-footer> -->
    <div class="pagefooter-box flex justify-content-space-around align-items">
      <div class="pagefooter">
        <div class="footer-menu page-width flex align-items">
          <div class="footer-menu-ever" style="margin-left: 50px" @click="navPath('1')">
            首页
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="footer-menu-ever" @click="navPath('2')">
            {{ titleMenu[0].name }}
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="footer-menu-ever" @click="navPath('3')">
            {{ titleMenu[1].name }}
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="footer-menu-ever" @click="navPath('4')">
            {{ titleMenu[2].name }}
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="footer-menu-ever" @click="navPath('5')">
            {{ titleMenu[3].name }}
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="footer-menu-ever" @click="navPath('6')">
            {{ titleMenu[4].name }}
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="footer-menu-ever" @click="navPath('7')">
            {{ titleMenu[5].name }}
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="footer-menu-ever" @click="navPath('8')">
            {{ titleMenu[6].name }}
          </div>
        </div>
        <div class="container footermarginTop">
          <div class="row footer-info">
            <div class="col-lg-4 col-md-12 col-sm-12 text-center">
              <img src="@/assets/logo.png" alt="" class="footer-logo" />
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 flex-column">
              <div class="footer-info-text">公司电话：{{ siteData.landline }}</div>
              <div class="footer-info-text">公司传真：{{ siteData.faxes }}</div>
              <div class="footer-info-text">营销专线：{{ siteData.marketingLine }}</div>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 flex-column">
              <div class="footer-info-text">邮箱：{{ siteData.email }}</div>
              <div class="footer-info-text">地址：{{ siteData.address }}</div>
              <div class="footer-info-text">版权所有：{{ siteData.copyright }}</div>
            </div>
          </div>
        </div>
        <div class="container footer-line"></div>
        <div
          class="container text-center wzxkz"
          style="font-size: 14px; color:#333333; margin-top: 10px"
        >
          网站备案/许可证号：<span class="beian" v-html="siteData.siteRecords"></span>
        </div>
      </div>
    </div>
    <!-- </el-footer> -->
    <!-- </el-container> -->
    <leftPin ref="leftPin" />
    <el-dialog
      top="20vh"
      :close-on-click-modal="clickmodalstatus"
      :visible.sync="dialogStatus"
      class="box-none"
    >
      <div class="flex login-box">
        <div style="width: 50%; height: 100%">
          <img src="@/assets/loginBgImg.png" alt="" style="width: 100%; height: 100%" />
        </div>
        <div style="width: 50%; height: 100%" class="login-right flex-column align-items">
          <img
            src="@/assets/loginlogo.png"
            alt=""
            style="width: 152px; height: 82px; margin-top: 40px"
          />
          <h3 style="color: #009acf; font-size: 20px; font-weight: 500; margin-top: 11px">
            陕西奉航科技有限责任公司
          </h3>
          <div class="login-input-box" style="width: 90%; margin-top: 50px">
            <el-input
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model="userPhone"
              @input="phoneChange"
              placeholder="请输入手机号码"
            ></el-input>
          </div>
          <div class="login-code flex align-items login-input-box" style="width: 90%">
            <el-input
              v-model="code"
              @input="codeChange"
              placeholder="请输入验证码"
            ></el-input>
            <span
              class="login-code-text page-click"
              @click="codeClick"
              v-if="codeStatus == ''"
              >获取验证码</span
            >
            <span
              class="login-code-text page-click"
              style="color: #999999 !important"
              v-if="codeStatus == '1'"
              >{{ codetime }}</span
            >
          </div>
          <el-button style="width: 90%; margin-top: 30px" type="primary" @click="tologin"
            >登录</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import leftPin from "@/components/leftPin";
import Directive from "@/utils/directive.js";
import Directive2 from "@/utils/directive.js";
export default {
  name: "homeHeader",
  components: {
    leftPin,
    Directive2,
  },
  data() {
    return {
      siteData: {},
      titleMenu: [],
      dialogStatus: false,
      userPhone: "",
      code: "",
      yzcode: "",
      codeStatus: "",
      codetime: "",
      totalTime: 61,
      loginStatus: "",
      logindata: {},
      overlay: false,
      show: false,
      menuStatus: false,
      clickmodalstatus: false,
      search: "",
      screenWidth: "",
      shopCarNum: 0,
    };
  },
  mounted() {
    var that = this;
    Directive2.$on("changeShopCarNum", function (res) {
      console.log(res);
      that.getCartCount();
    });
    Directive.$on("login", function (res) {
      console.log(res);
      if (res > 1199) {
        that.loginClick();
      } else {
        that.showPopup();
      }
    });
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  watch: {
    screenWidth(val) {
      // 先判断是否打开了弹出层
      if (this.dialogStatus == true || this.show == true) {
        // 监听宽度
        if (val <= 1200) {
          if (this.loginStatus == "") {
            this.dialogStatus = false;
            this.show = true;
          }
        } else {
          if (this.loginStatus == "") {
            this.show = false;
            this.dialogStatus = true;
          }
        }
      }
    },
  },
  created() {
    if (JSON.parse(window.localStorage.getItem("siteData")) == null) {
      this.getCompanyInfo();
    } else {
      this.siteData = JSON.parse(window.localStorage.getItem("siteData"));
    }
    if (JSON.parse(window.localStorage.getItem("userinfo")) == null) {
    } else {
      this.loginStatus = "1";
      this.logindata = JSON.parse(window.localStorage.getItem("userinfo"));
      this.getCartCount();
    }
    if (JSON.parse(window.localStorage.getItem("titleMenu")) == null) {
      this.getAboutFhNavigation();
    } else {
      this.titleMenu = JSON.parse(window.localStorage.getItem("titleMenu"));
    }
  },
  methods: {
    getCartCount() {
      this.$api.iotHome
        .cartCount({
          customerId: this.logindata.id,
        })
        .then((res) => {
          if (res.success) {
            this.shopCarNum = res.data;
          }
        });
    },
    getAboutFhNavigation() {
      this.$api.iotHome
        .aboutFhNavigation({
          cmsColumnId: "0",
        })
        .then((res) => {
          if (res.success == true) {
            window.localStorage.setItem("titleMenu", JSON.stringify(res.data));
            this.titleMenu = res.data;
          }
        });
    },
    searchChange(val) {
      this.search = this.search.replace(/\s*/g, "");
      if (this.search != "") {
        this.menuStatus = false;
        this.$router.push({
          path: "/search",
          query: {
            code: this.search,
          },
        });
      } else {
        this.$message({
          message: "请输入搜索关键字",
          type: "warning",
          offset: "50",
        });
      }
    },
    searchInput(val) {
      this.search = val;
    },
    inputclick(val) {
      console.log(val);
    },
    getCompanyInfo() {
      this.$api.iotHome.companyInfo().then((res) => {
        if (res.success == true) {
          window.localStorage.setItem("siteData", JSON.stringify(res.data));
          this.siteData = res.data;
        }
      });
    },
    mobMenu() {
      this.show = false;
      this.menuStatus = !this.menuStatus;
    },
    loginClick() {
      this.dialogStatus = true;
    },
    phoneChange(val) {
      this.userPhone = val;
    },
    codeChange(val) {
      this.code = val;
    },
    tologin() {
      var strcode = this.yzcode.toString();
      if (this.code != "" && this.userPhone != "") {
        if (this.code == strcode) {
          this.$api.iotHome
            .login({
              PhoneNumbers: this.userPhone,
            })
            .then((res) => {
              if (res.success == true) {
                window.localStorage.setItem("userinfo", JSON.stringify(res.data));
                this.loginStatus = "1";
                this.logindata = res.data;
                this.dialogStatus = false;
                this.show = false;
                this.getCartCount();
              }
            });
        }
      } else {
        this.$message.error("请输入正确的验证码");
      }
    },
    backlogin() {
      this.$confirm("是否退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.loginStatus = "";
          window.localStorage.clear();
          this.$router.replace({
            path: "/",
          });
        })
        .catch(() => {});
    },
    codeClick() {
      if (this.userPhone != "") {
        this.$api.iotHome
          .SendMessage({
            PhoneNumbers: this.userPhone,
          })
          .then((res) => {
            // this.yzcode = res.toString();
            this.yzcode = res.code;
            this.codeStatus = "1";
            let clock = window.setInterval(() => {
              if (this.totalTime > 0) {
                this.totalTime--;
                this.codetime = this.totalTime + "s后重新发送";
              } else {
                this.codeStatus = "";
                this.totalTime = 61;
                clearInterval(clock);
              }
            }, 1000);
          });
      }
    },
    closeshowPopup() {
      this.show = false;
    },
    toHome() {
      this.$router.replace({
        path: "/",
      });
    },
    showPopup() {
      window.localStorage.removeItem("changeStatus");
      if (this.loginStatus == "") {
        this.show = true;
      } else {
        this.$router.push({
          path: "/user",
        });
      }
    },
    tofixationPath(index) {
      if (index == 1) {
        this.$router.push({
          path: "/back",
          query: {
            path: "/aboutus",
          },
        });
        window.localStorage.setItem("changeStatus", "10207");
      } else {
        this.$router.push({
          path: "/back",
          query: {
            path: "/customer",
          },
        });
        window.localStorage.setItem("changeStatus", "10605");
      }
    },
    toPath(e, index) {
      window.localStorage.setItem("changeStatus", e);
      var obj = {
        1: "/",
        2: "/aboutus",
        3: "/news",
        4: "/product",
        5: "/technology",
        6: "/customer",
        7: "/culture",
        8: "/working",
        9: "/shopcar",
        10: "/user",
      };
      this.$router.push({
        path: "/back",
        query: {
          path: obj[index],
        },
      });
    },
    navPath(index) {
      this.menuStatus = false;
      window.localStorage.removeItem("changeStatus");
      var obj = {
        1: "/",
        2: "/aboutus",
        3: "/news",
        4: "/product",
        5: "/technology",
        6: "/customer",
        7: "/culture",
        8: "/working",
        9: "/shopcar",
        10: "/user",
      };
      if (index == 9) {
        if (this.screenWidth <= 1200) {
          if (this.loginStatus == "") {
            this.show = true;
            this.dialogStatus = false;
          }
        } else {
          if (this.loginStatus == "") {
            this.show = false;
            this.dialogStatus = true;
          }
        }
      }
      if (index == 10) {
        if (this.loginStatus == "") {
          //   未登录
          this.dialogStatus = true;
        } else {
          //   登录
          this.$router.push({
            path: "/back",
            query: {
              path: obj[index],
            },
          });
        }
      } else {
        this.$router.push({
          path: "/back",
          query: {
            path: obj[index],
          },
        });
      }
    },
  },
};
</script>
<style></style>
<style lang="scss" scope>
.welcome {
  width: 100%;
  height: 34px;
  background: #f1f1f1;
}

.searchLogo {
  width: 100%;
  height: 117px;
}

.el-divider--vertical {
  margin: 0 !important;
}

.tabnav {
  width: 100%;
  height: 52px;
  background: #0090ff;
  color: #ffffff;
  font-size: 16px;
}

.tabnav-ever {
  padding-left: 25px;
  padding-right: 25px;
  height: 52px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
}

.tabnav-ever:hover {
  background: #0f76c5;
}

.pageTitle-text {
  font-size: 20px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  color: #009acf;
}

.pageTitle-text-fu {
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  text-align: left;
  color: #999999;
}

.pageTitle-phone {
  font-size: 28px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  color: #b91313;
}

.pageTitle-phone-fu {
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  color: #666666;
}

.mobheader {
  width: 100%;
  height: 50px;
  background: #f9f9f9;
  position: fixed;
  top: 0;
  z-index: 9999;
}

.mobheader-box {
  width: 92%;
  margin-left: 4%;
  height: 100%;
}

.mobheader-logo > img {
  width: 55px;
  height: 30px;
}

.mobheader-logo > p {
  width: 55px;
  font-size: 12px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  text-align: center;
  color: #00b3ff;
}

.mobheader-logo,
.mobheader-user,
.mobheader-menu {
  height: 100%;
}

.mobheader-user > img {
  width: 25px;
  height: 25px;
}

.mobheader-user > img:last-child {
  margin-left: 20px;
}

.mobheader-menu > img {
  width: 25px;
}

.pagefooter-box {
  width: 100%;
  background: #f9f9f9;
}

.pagefooter {
  padding-top: 30px;
  padding-bottom: 10px;
}

.footer-menu {
  margin-left: 100px;
}

.footer-menu-ever {
  width: 111px;
  font-size: 15px;
  font-family: Source Han Sans CN, Source Han Sans CN-Medium;
  font-weight: 500;
  text-align: center;
  color: #333333;
  cursor: pointer;
}

.footer-menu-ever:hover {
  color: #0090ff;
}

.footer-line {
  height: 1px;
  background: #dbdbdb;
}

.pageHeader-logo {
  font-size: 15px;
}

.el-dialog {
  border-radius: 10px;
}

.el-dialog__body {
  padding: 0px !important;
}

.el-dialog__header {
  padding: 0px !important;
}

.el-dialog__headerbtn {
  z-index: 9999;
  top: 5px !important;
  right: 10px !important;
  font-size: 20px !important;
}

.login-code {
  position: relative;
  margin-top: 25px;
}

.login-code-text {
  position: absolute;
  right: 10px;
  color: #0090ff;
  font-size: 14px;
}

[class*="van-hairline"]::after {
  border: 0px solid transparent !important;
}

.mob-line >>> .van-cell {
  border-bottom: 1px solid #ebedf0 !important;
}

.login-input-box,
.el-input__inner {
  border-radius: 4px !important;
  background: #f9f9f9 !important;
}

.van-cell {
  border-bottom: 1px solid #dbdbdb !important;
}

.mob-login-btn {
  margin-top: 20px;
  width: 143px;
  height: 36px;
  background: #00b3ff;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 20px;
}

.footer-info-text {
  color: #666666;
  font-size: 15px;
  line-height: 30px;
}

.footermarginTop {
  margin-top: 50px;
  margin-bottom: 25px;
}

.beian > a {
  font-size: 14px;
  color: #333333;
  text-decoration: none;
}

.mob-menulist > .van-search {
  padding: 10px 0px !important;
}

.mob-menulist > .van-cell {
  border-bottom: 0px solid transparent !important;
}

.van-search__content > .van-cell {
  border-bottom: 2px solid #dbdbdb !important;
}

.mob-menulist .van-search__content {
  padding-left: 15px !important;
  padding-right: 15px !important;
  background: #ffffff !important;
}

.el-input-zdy > .el-input__inner {
  border: 1px solid #0090ff !important;
  background: #ffffff !important;
  border-radius: 25px !important;
}

.van-field__left-icon .van-icon,
.van-field__right-icon .van-icon {
  display: none !important;
}

.el-badge__content.is-fixed {
  top: 10px !important;
  right: 30px !important;
}
</style>
